<template>
  <el-dialog
    :visible.sync="dialogShow"
    :before-close="handleClose"
    width="600px"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="true"
    :destroy-on-close="true"
    :show-close="false"
  >
    <div slot="title" class="flex align-items-center">
      <div class="bd font-lg">显示条件设置</div>
      <div class="ft flex font-md text-muted">
        <!-- 增加tooltip -->
        <el-tooltip effect="dark" content="删除" placement="top">
           <i v-if="sensors[0].cond_senid" role="button" class="iconfont icon-delete icon-btn" @click="handleDelete"></i>
        </el-tooltip>
        <div v-if="openType == 'single' && sensors[0].cond_senid" style="border-left: 1px solid #ccc;" class="ml"></div>
        <el-tooltip effect="dark" content="关闭" placement="top">
          <i role="button" class="iconfont icon-fork icon-btn" @click="handleClose"></i>  
        </el-tooltip>
      </div>
    </div>
    <div class="pl-md pr-md" style="border-bottom:1px solid #DCDFE6;">
      <div class="mb-md">当满足下列条件时：</div>
      <el-form ref="conditionForm" class="mb-xs" :inline="true" :model="formData" :rules="formRules">
        <el-form-item prop="cond_senid">
          <sen-selector v-model="formData.cond_senid" :sens="sens" placeholder="请选择参数" @change="handleTriggerType" style="width: 200px;" />
        </el-form-item>

        <el-form-item v-if="formData.cond_senid" prop="cond_value">
          <el-input
            v-if="trigger_sen.sen_type == 1"
            v-model.number="formData.cond_value"
            style="width: 100px"
            type="number"
            placeholder="Value"
          />
          <el-select v-if="trigger_sen.sen_type == 2" v-model="formData.cond_value" filterable placeholder="请选择" style="width: 200px;">
            <el-option
              v-for="(value,key) in trigger_sen.field1"
              :key="key"
              :label="value"
              :value="value"
            />
          </el-select>
          <el-radio-group
            v-if="trigger_sen.sen_type == 3"
            v-model="formData.cond_value"
            size="medium"
            style="margin-top: -4px;"
          >
            <el-radio-button :label="1">ON</el-radio-button>
            <el-radio-button :label="0">OFF</el-radio-button>
          </el-radio-group>

          <el-input
            v-if="trigger_sen.sen_type == 4"
            v-model.number="formData.cond_value"
            style="width: 160px"
            placeholder="Value"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="pr-md pl-md">
      <div class="mt-md">显示下列参数：</div>
      <div class="text-primary pt-md pb-md">
        <span v-for="(sen,index) in sensors" :key="sen.senid">{{ sen.sen_name }}<span v-if="index + 1 != sensors.length">、</span></span>
      </div>
      <div class="pl pr pt-sm pb-sm text-warning" style="background-color: rgba(240, 173, 78, .1);">
        <i class="iconfont icon-basic-information font-md mr-xs"></i><span>设置后，需保存设置才能生效！</span>
      </div> 
    </div>
    <div class="flex-center mt-md">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "ConditionEditDialog",

  components: {
    SenSelector: () => import('./SenSelector.vue')
  },

  props: {
    show: {
      type: Boolean,
    },
    sensors: {
      type: Array,
    },
    openType: {
      type: String,
    },
  },

  data() {
    return {
      formData: {
        cond_senid: null,
        cond_value: null,
      },
      formRules: {
        cond_value: [
          {
            required: true,
            message: "请输入触发值",
            trigger: "blur",
          },
        ],

        cond_senid: [
          {
            required: true,
            message: "请选择触发参数",
            trigger: "change",
          },
        ],
      }
    };
  },

  computed: {
    dialogShow: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },

    dev() {
      return this.$store.state.devStore.dev;
    },

    sens() {
      const models = this.$store.state.devStore.models;
      if (!models.length) return [];
      let sens = [];
      models.forEach((v) => {
        if (this.dev.protocal == 'MQTT') {
          sens = sens.concat(v.sens)
        } else {
          if(v.cmd.cmdid) sens = sens.concat(v.sens);
        }
      });
      return sens;
    },

    trigger_sen() {
      return this.sens.find((v) => v.senid == this.formData.cond_senid);
    },
  },

  created() {
    this.openType == "single" && this.handleSingleData();
  },

  methods: {
    handleClose() {
      this.dialogShow = false;
    },

    handleDelete() {
      let sens_name_str = this.sensors.map(item=>{
        return item.sen_name
      }).join('、');

      this.$confirm(`此操作将清空参数 <span class="text-success font-md">${sens_name_str}</span> 的显示条件 ，是否继续？`, '条件清空',{
        type: 'warning',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.$emit("delete");
        this.handleClose();
      }).catch(() => {
        // 取消删除
      })
    },

    handleTriggerType() {
      // 如果参数类型为开关型，默认值给ON,其他类型给null
      if(this.trigger_sen.sen_type == 3) {
        this.formData.cond_value = 1
      } else {
        this.formData.cond_value = null
      }
    },

    handleSingleData() {
      if(!this.sensors[0].cond_senid) return
      this.formData.cond_value = this.sensors[0].cond_value;
      this.formData.cond_senid = this.sensors[0].cond_senid;
    },

    submit() {
      this.$refs.conditionForm.validate((valid) => {
        if (valid) {
          this.$emit("submit", this.formData);
          this.handleClose();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/input::-webkit-outer-spin-button {
  -webkit-appearance: none;
}
/deep/input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
/* Firefox */
/deep/input[type='number']{
  -moz-appearance: textfield;
}
</style>